// NominateWinnerDialog.jsx
import React, { useContext, useEffect, useState } from 'react';
import {
  Dialog,
  Grid,
  Typography,
  Box,
  InputBase,
  Button,
  CircularProgress,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
// import Pendingwarning from "./Pendingwarning"; // adjust path if needed
import Swal from 'sweetalert2';
import { Moxoseparationinlisting, postApiCall } from 'api/apiService';
import { PUBLISH_WINNER } from 'constant/app.config';
import Requestdeposit from 'component/BuyerRegistration/components/RequestDepositPopup';
import SelectAlternateWinnerDialog from './SelectAlternateWinner';
import { poppins400, poppins300, poppins500 } from 'theme/common.style';
import DetailsPopup from 'component/VendorStatusContainer/DepositManager/StatusDetailsPopups/DetailsPopup';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min';
import { datacontext } from 'modules/AppLayout/AppLayout';
import Loading from 'assets/images/loading.png';

const Pendingwarning = () => {
  return (
    <svg
      width="38"
      height="36"
      viewBox="0 0 38 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="37.5797"
        height="36"
        rx="18"
        fill="#F39800"
        fill-opacity="0.1"
      />
      <path
        d="M27.0817 21.4607L21.3085 11.456C20.7883 10.5551 19.8271 10 18.7866 10C17.7462 10 16.7851 10.5551 16.2648 11.456L10.3902 21.632C9.86994 22.5329 9.86994 23.6431 10.3902 24.544C10.9104 25.4449 11.8715 26 12.912 26H24.6614C24.6646 26 24.6677 26 24.6677 26C26.276 26 27.5797 24.6962 27.5797 23.088C27.5797 22.4853 27.3957 21.9239 27.0817 21.4607ZM20.0333 22.4345C20.0333 23.1229 19.5036 23.6495 18.7898 23.6495C18.0761 23.6495 17.5464 23.1229 17.5464 22.4345V22.406C17.5464 21.7208 18.0761 21.1911 18.7898 21.1911C19.5036 21.1911 20.0333 21.7177 20.0333 22.406V22.4345ZM20.0619 14.2443L19.4465 19.6178C19.4052 20.0048 19.1483 20.2458 18.7898 20.2458C18.4314 20.2458 18.1745 20.0016 18.1332 19.6178L17.5178 14.2411C17.4766 13.8255 17.7019 13.5115 18.0888 13.5115H19.4877C19.8747 13.5147 20.1031 13.8287 20.0619 14.2443Z"
        fill="#F39800"
      />
    </svg>
  );
};

const NominateWinnerDialog = ({
  open,
  onClose,
  matchessm,
  propAddress,
  profileDetails,
  buyerId,
  setOpenPublishWinnerBox,
  getdata,
  getListInfo,
}) => {
  // const [openpublishwinnerbox, setOpenPublishWinnerBox] = useState(false);
  const [publishLoader, setPublishLoader] = useState(false);
  const [openSelectBuyer, setOpenSelectBuyer] = useState(false);
  const [selectedBuyer, setSelectedBuyer] = useState();

  const [fromFlow, setFromFlow] = useState(false);
  const [depositdetails, setDepositdetails] = useState(false);
  const [requestdeposit, setRequestdeposit] = useState(false);
  const [reDepositOpen, setReqDepositOpen] = useState(false);
  const [depositRes, setDepositRes] = useState('');
  const history = useHistory();
  const location = useLocation();

  const { setWinerPublishdMoveToEnded, setwinnerPopper } =
    useContext(PropertyContext);

  const { bannerApiTrigger } = useContext(datacontext);
  const isAlternativeWinnerDepositCompleted =
    Math.round(Number(selectedBuyer?.buyerOfferPrice) * 100) ===
    Math.round(Number(selectedBuyer?.requestedDepositAmount) * 100);

  const alternateWinnerBuyerId = selectedBuyer?.buyerDetails?.user?.userId;

  useEffect(() => {
    setDepositRes(selectedBuyer?.buyerOfferDetails?.depositPaymentLog);
  }, [selectedBuyer]);

  const selectedBuyerName = `${selectedBuyer?.buyerDetails?.user?.userName} ${selectedBuyer?.buyerDetails?.user?.userSurName}`;

  const isNotEmptyArray = (arr) =>
    Array.isArray(arr) &&
    arr.length > 0 &&
    !arr.every((item) => Array.isArray(item) && item.length === 0);

  const moxoapis = (res) => {
    if (isNotEmptyArray(res?.data?.dataForST2EndedBuyerAck))
      Moxoseparationinlisting(
        'dataForST2EndedBuyerAck',
        res?.data?.dataForST2EndedBuyerAck
      ); //1
    if (isNotEmptyArray(res?.data?.dataForST2EndedVendorAck))
      Moxoseparationinlisting(
        'dataForST2EndedVendorAck',
        res?.data?.dataForST2EndedVendorAck
      ); //2
    if (isNotEmptyArray(res?.data?.dataForWinnerVendorAck))
      Moxoseparationinlisting(
        'dataForWinnerVendorAck',
        res?.data?.dataForWinnerVendorAck
      ); //3
    if (isNotEmptyArray(res?.data?.dataForWinnerBuyerAck))
      Moxoseparationinlisting(
        'dataForWinnerBuyerAck',
        res?.data?.dataForWinnerBuyerAck
      ); //4
  };

  const handleCloseSelectBuyer = () => {
    setOpenSelectBuyer(false);
  };

  const handleNominate = async () => {
    setPublishLoader(true);
    const params = {
      offerUniqueId: selectedBuyer?.buyerOfferDetails?.offerUniqueId,
      isAlternateWinner: 1,
    };
    postApiCall(PUBLISH_WINNER, params)
      .then((res) => {
        if (res?.data?.status == 1) {
          bannerApiTrigger();
          history.replace({
            ...history.location,
            state: { ...location.state, fromDashBoard: false },
          });
          setOpenPublishWinnerBox(false);
          setPublishLoader(false);
          getdata();
          getListInfo();
          moxoapis(res);
          // setWinerPublishdMoveToEnded(true);
          setwinnerPopper(true);
          setTimeout(() => {
            Swal.fire({
              icon: 'success',
              title: res?.data?.heading ? res?.data?.heading : 'Success',
              html: `${
                profileDetails?.PropertyDetails?.timerStatus !== 'End'
                  ? (profileDetails?.PropertyDetails?.stage === 'ST1'
                      ? 'Stage 1'
                      : 'Stage 2') + ' has now ended. '
                  : ''
              }<b style="font-family: Poppins; font-weight: 550; color: #666666;">
  ${selectedBuyer?.buyerDetails?.user?.userName} ${
                selectedBuyer?.buyerDetails?.user?.userSurName
              }
</b> has been nominated as the Winner.`,

              showConfirmButton: true,
              showCancelButton: true,
              confirmButtonText: isAlternativeWinnerDepositCompleted
                ? 'View deposit details'
                : 'Request deposit',

              cancelButtonText: isAlternativeWinnerDepositCompleted
                ? 'Close'
                : 'Close',

              reverseButtons: true,
            }).then(({ isConfirmed, isDismissed }) => {
              if (isConfirmed) {
                setFromFlow(true);
                if (isAlternativeWinnerDepositCompleted) {
                  setDepositdetails(true);
                  return;
                } else {
                  setRequestdeposit(true);
                  return;
                }
              } else if (isDismissed) {
                return;
              }
            });
          }, 6000);
        } else {
          Swal.fire({
            icon: 'error',
            title: res?.data?.heading ? res?.data?.heading : 'Error',
            text: res?.data?.message,
            confirmButtonText: 'Close',
          });
          setOpenPublishWinnerBox(false);
          setPublishLoader(false);
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'An error occurred while nominating the winner. Please try again later.',
        }).then(() => {
          setOpenPublishWinnerBox(false);
        });

        setPublishLoader(false);
      })
      .finally(() => {
        // setEndPropertyPopupFromNominateWinner(true);
      });
  };

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '95%' : '400px',
            boxShadow: '-4px 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '30px 20px' : '30px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '10px' : '14px',
                color: '#666666',
              }}
            >
              {propAddress}&nbsp;
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            display="flex"
            alignItems="center"
            padding="12px 0px 15px 0"
          >
            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '16px' : '24px',
                paddingLeft: '12px',
              }}
            >
              {profileDetails?.PropertyDetails?.timerStatus !== 'Start'
                ? 'Nominate Winner'
                : `Nominate Winner - End Stage ${
                    profileDetails?.PropertyDetails?.stage === 'ST1' ? '1' : '2'
                  }`}
            </Typography>
          </Grid>

          {/* Buyer Input */}
          <Grid container alignItems="center" spacing={2}>
            <Grid item>
              <Typography
                sx={{
                  ...poppins400,
                  fontSize: matchessm ? '12px' : '16px',
                  color: '#666666',
                }}
              >
                Buyer Name:
              </Typography>
            </Grid>
            <Grid item>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: '#f5f5f5',
                  borderRadius: '999px',
                  padding: '6px 16px',
                  width: '250px',
                }}
              >
                <SearchIcon sx={{ marginRight: 1 }} />
                <InputBase
                  placeholder="Search Buyer"
                  fullWidth
                  sx={{
                    ...poppins300,
                    fontSize: matchessm ? '12px' : '16px',
                    color: '#666666',
                  }}
                  onClick={() => setOpenSelectBuyer(true)}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Confirmation Text */}
          <Grid item xs={12} textAlign="left" paddingTop="10px">
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '16px',
                color: '#666666',
                width: '100%',
              }}
              whiteSpace="wrap"
            >
              Do you want to proceed with nominating{' '}
              <Box component="span" sx={{ fontWeight: 600 }}>
                {selectedBuyer?.buyerDetails?.user?.userName}{' '}
                {selectedBuyer?.buyerDetails?.user?.userSurName}
              </Box>{' '}
              as the winner?
            </Typography>
          </Grid>

          {/* Action Buttons */}
          <Grid
            item
            container
            direction="row"
            justifyContent="flex-end"
            gap={matchessm ? '5px' : 2}
            marginTop={matchessm ? '15px' : 5}
            alignItems="center"
          >
            <Grid item>
              <Button
                disabled={publishLoader}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 18px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
                onClick={onClose}
              >
                Cancel
              </Button>
            </Grid>

            <Grid
              item
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '15px',
              }}
            >
              <Button
                disabled={publishLoader || !selectedBuyer}
                variant="outlined"
                style={{
                  padding: matchessm ? '7px 17px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'none',
                  opacity: !selectedBuyer ? 0.5 : 1,
                }}
                onClick={handleNominate}
              >
                Nominate
              </Button>
            </Grid>
            {publishLoader && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: matchessm ? '35px' : '41px',
                  width: matchessm ? '35px' : '41px',
                }}
              >
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              </Box>
            )}
          </Grid>
        </Grid>
      </Dialog>

      <SelectAlternateWinnerDialog
        open={openSelectBuyer}
        onClose={handleCloseSelectBuyer}
        tableData={profileDetails}
        selectedBuyer={selectedBuyer}
        setSelectedBuyer={setSelectedBuyer}
      />

      {depositdetails && (
        <DetailsPopup
          openDetailsPopup={depositdetails}
          handleCloseDetails={() => {
            setDepositdetails(false);
          }}
          profileDetails={profileDetails}
          buyerId={alternateWinnerBuyerId}
          isFromBuyerRegister={true}
          getListInfo={getListInfo}
        />
      )}

      {requestdeposit && (
        <Requestdeposit
          requestdeposit={requestdeposit}
          //  endPropertyPopupFromNominateWinner={endPropertyPopupFromNominateWinner}
          setRequestdeposit={setRequestdeposit}
          setReqDepositOpen={setReqDepositOpen}
          //  contractAppLoader={contractAppLoader}
          //  setContractAppLoader={setContractAppLoader}
          selectedrowbuyerid={alternateWinnerBuyerId}
          //  getListInfo={getListInfo}
          selectedrowbuyername={selectedBuyerName}
          row={selectedBuyer}
          //  reqDepositOpen={reqDepositOpen}
          address={propAddress}
          depositRes={depositRes}
          fromFlow={fromFlow}
          profileDetails={profileDetails}
        />
      )}
    </>
  );
};

export default NominateWinnerDialog;
